<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose">
    <el-form :model="addHousekeepingFeeConfigRelInfo" label-width="120px">
      <el-form-item v-if="addHousekeepingFeeConfigRelInfo.servId" label="服务类型" prop="hktId" required>
        <el-select 
          v-model="addHousekeepingFeeConfigRelInfo.hktId" 
          placeholder="必填，请填写服务类型"
          style="width:100%">
          <el-option 
            v-for="item in addHousekeepingFeeConfigRelInfo.housekeepingTypes"
            :key="item.hktId"
            :label="item.hktName"
            :value="item.hktId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="费用大类" prop="feeTypeCd" required>
        <el-select 
          v-model="addHousekeepingFeeConfigRelInfo.feeTypeCd" 
          placeholder="必填，请填写费用大类"
          @change="_listRelAddHousekeepingFeeConfigs"
          style="width:100%">
          <el-option 
            v-for="item in addHousekeepingFeeConfigRelInfo.housekeepingFeeTypes"
            :key="item.feeTypeCd"
            :label="item.typeName"
            :value="item.feeTypeCd">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="费用标准" prop="configId" required>
        <el-select 
          v-model="addHousekeepingFeeConfigRelInfo.configId" 
          placeholder="必填，请填写费用标准"
          @change="setAddFeeName"
          style="width:100%">
          <el-option 
            v-for="item in addHousekeepingFeeConfigRelInfo.housekeepingFeeConfigs"
            :key="item.configId"
            :label="item.feeName"
            :value="item.configId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="saveHousekeepingFeeConfigRelInfo">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { 
  queryHousekeepingFeeType,
  queryHousekeepingType,
  queryHousekeepingFeeConfig,
  saveHousekeepingServFee
} from '@/api/housekeeping/housekeepingServFeeApi'

export default {
  name: 'AddHousekeepingFeeConfigRel',
  data() {
    return {
      dialogVisible: false,
      addHousekeepingFeeConfigRelInfo: {
        configId: '',
        feeName: '',
        hktId: '',
        feeTypeCd: '',
        servId: '',
        servName: '',
        housekeepingFeeTypes: [],
        housekeepingFeeConfigs: [],
        housekeepingTypes: []
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.clearaddHousekeepingFeeConfigRelInfo()
      this.addHousekeepingFeeConfigRelInfo.servId = params._servId
      this.addHousekeepingFeeConfigRelInfo.servName = params._servName
      this._listRelAddHousekeepingFeeTypes()
      this._listRelAddHousekeepingTypes()
    },
    handleClose() {
      this.dialogVisible = false
    },
    addHousekeepingFeeConfigRelValidate() {
      if (!this.addHousekeepingFeeConfigRelInfo.feeTypeCd) {
        this.$message.error('费用大类不能为空')
        return false
      }
      if (!this.addHousekeepingFeeConfigRelInfo.configId) {
        this.$message.error('费用标准不能为空')
        return false
      }
      return true
    },
    saveHousekeepingFeeConfigRelInfo() {
      if (!this.addHousekeepingFeeConfigRelValidate()) return

      this.addHousekeepingFeeConfigRelInfo.shopId = getShopId()
      saveHousekeepingServFee(this.addHousekeepingFeeConfigRelInfo)
        .then(res => {
          console.log(res)
          this.$message.success('添加成功')
          this.handleClose()
          this.$emit('refresh')
        })
        .catch(err => {
          this.$message.error(err.msg || '添加失败')
        })
    },
    _listRelAddHousekeepingFeeTypes() {
      queryHousekeepingFeeType({
        page: 1,
        row: 50,
        shopId: getShopId()
      }).then(res => {
        this.addHousekeepingFeeConfigRelInfo.housekeepingFeeTypes = res.data
      }).catch(err => {
        console.error('请求失败处理', err)
      })
    },
    _listRelAddHousekeepingTypes() {
      queryHousekeepingType({
        page: 1,
        row: 50,
        typeCd: 1001,
        shopId: getShopId()
      }).then(res => {
        this.addHousekeepingFeeConfigRelInfo.housekeepingTypes = res.data
      }).catch(err => {
        console.error('请求失败处理', err)
      })
    },
    _listRelAddHousekeepingFeeConfigs(feeTypeCd) {
      queryHousekeepingFeeConfig({
        page: 1,
        row: 50,
        shopId: getShopId(),
        feeTypeCd: feeTypeCd
      }).then(res => {
        this.addHousekeepingFeeConfigRelInfo.housekeepingFeeConfigs = res.data
      }).catch(err => {
        console.error('请求失败处理', err)
      })
    },
    setAddFeeName(configId) {
      const item = this.addHousekeepingFeeConfigRelInfo.housekeepingFeeConfigs.find(
        item => item.configId === configId
      )
      if (item) {
        this.addHousekeepingFeeConfigRelInfo.feeName = item.feeName
      }
    },
    clearaddHousekeepingFeeConfigRelInfo() {
      const { housekeepingFeeTypes, housekeepingFeeConfigs, housekeepingTypes } = this.addHousekeepingFeeConfigRelInfo
      this.addHousekeepingFeeConfigRelInfo = {
        configId: '',
        feeName: '',
        hktId: '',
        feeTypeCd: '',
        servId: '',
        servName: '',
        housekeepingFeeTypes,
        housekeepingFeeConfigs,
        housekeepingTypes
      }
    }
  }
}
</script>